export default "assets/images/icons/marker2-bce3e533.svg";